import * as Yup from 'yup';
import { ExportTemplate } from '@eas/common-web';
import { KsExportAccessRule } from '../../../../common/models';

export function useValidationSchema() {
  return Yup.object<KsExportAccessRule>().shape({
    template: Yup.object<ExportTemplate>().nullable().required(),
  });
}
